import * as pathToRegexp from 'path-to-regexp';
import { ReportRoutes } from '../boot/routeConfig';
import { history } from '../boot/configureStore';
import moment from 'moment';

class _reportUrl {
    isReportUrlWithDate(url) {
        if (url == null) return;
        const path1Test = this._testUrl(ReportRoutes.ruleInstanceId_Date, url);
        const path2Test = this._testUrl(ReportRoutes.ruleInstanceId_Index_List_Date, url);

        if (path1Test != null || path2Test != null)
            return true;
        else
            return false;
    }
    updateReportUrlWithDate(startDate, endDate) {
        if (startDate == null && endDate == null) return;
        const start = moment(startDate).format('YYYY-MM-DD');
        const end = moment(endDate).format('YYYY-MM-DD');
        const url = history.location.pathname;

        const path1Test = this._testUrl(ReportRoutes.ruleInstanceId, url);
        const path2Test = this._testUrl(ReportRoutes.ruleInstanceId_Index_List, url);
        const path3Test = this._testUrl(ReportRoutes.ruleInstanceId_Date, url);
        const path4Test = this._testUrl(ReportRoutes.ruleInstanceId_Index_List_Date, url);

        let newUrl = null;
        if (path1Test != null || path2Test != null)
            newUrl = `${url}/${start},${end}`;
        else if (path3Test != null)
            newUrl = url.replace(path3Test[2], `${start},${end}`);
        else if (path4Test != null)
            newUrl = url.replace(path4Test[4], `${start},${end}`);

        if (newUrl != null)
            history.replace(newUrl, null);
    }

    _testUrl(path, urlToTest) {
        return pathToRegexp(path).exec(urlToTest);
    }
}
export const ReportUrl = new _reportUrl();


// WEBPACK FOOTER //
// ./src/services/reportUrl.js